import React, { Component } from 'react';
import { isEmpty } from "lodash";

import HighChartStack from './Charts/HighChartStack';
import { Card, Grid, Box } from '@mui/material';
import { InputSelectNative } from '../common/Form';
import { groupByMonth, getLimitDate, getDateLabels, countList, sumList, getLabelsCustom } from './statsFunctions';

class StackedGeneral extends Component {
    state = { 
        year: new Date().getFullYear()
    }

    filterData = () => {
		const { filter_period, filter_payment, SPENDINGS, view, start_date, end_date } = this.props;
		let from = filter_period === "custom" ? start_date :  getLimitDate(filter_period)
		let list = this.filterDate(SPENDINGS, from, end_date)
		if ( filter_payment && filter_payment !== "all" ) {
			list = this.filterPayment(list, filter_payment)
		}
		let nbPerCatlist = countList(list, "spending_category")
        let topCats = Object.keys(nbPerCatlist).sort( (a, b) => nbPerCatlist[b] - nbPerCatlist[a])

        return {list, topCats}
	}

	filterDate = (list, from, to ) => {
		console.log('====================================');
		console.log({to});
		console.log('====================================');
		if(!to){
			to = Date.now()
		}
        new Date(from).setHours(0,0,0,0)
		new Date(to).setHours(0,0,0,0)
        
		let filteredList = Object.values(list).filter( spending => 
			new Date(spending.spending_date) >= from 
			&& new Date(spending.spending_date) <= to
		)

		return filteredList
	}
	filterPayment = (list, filter_payment) => {
		let fully_paid = filter_payment === "fully_paid" ? true : false; 

		let filteredList = list.filter( spending => 
			spending.spending_fully_paid === fully_paid 
		)

		return filteredList
    }
    
    
    calcData = () => {
        const { CATEGORIES, filter_payment, start_date, end_date, view } = this.props;
        let sum = {}
        let series = []
        let bckg = []
        let formatted = {}
        let info = this.filterData()
        
        // console.log('====================================');
        // console.log({info, CATEGORIES});
        // console.log('====================================');
        let list = info.list
        let catList = info.topCats
        let dateLabels = getLabelsCustom(start_date, end_date)
        let amountField = filter_payment === "rest_to_pay" ? "spending_rest_to_pay" : "spending_amount"; 

        let categories = groupByMonth(list, "spending_date")
        // let categories = this.props.filter_period === "year" ? groupByMonth(list, "spending_date") : groupByDate(list, "spending_date")

        dateLabels.forEach( date => {
            sum[date] = categories[date] ? sumList(categories[date], "spending_category", amountField) : {}
        })
     
        catList.forEach(cat => {
            Object.values(sum).forEach( data => {
                if(!formatted[cat]){
                    formatted[cat] = []
                }
                formatted[cat].push(data[cat] || 0)
            })
        })
        Object.keys(formatted).forEach( catID => {
            series.push({
                name: !isEmpty(CATEGORIES) && CATEGORIES[catID] && 
                    `${CATEGORIES[catID].category_name}`,
                data: formatted[catID],
            })
            let color = !isEmpty(CATEGORIES[catID]) ? CATEGORIES[catID].category_color : "#bbbfbf" 
            bckg.push(color)
        })

        return {categories : dateLabels, series, bckg}
    }

    render() {
        const { SPENDINGS, CATEGORIES } = this.props;
        let info_stack = !isEmpty(SPENDINGS) && !isEmpty(CATEGORIES) ? this.calcData() : {}
        console.log('=================STACKED STATS===================');
        console.log({SPENDINGS});
        console.log('====================================');
        return (
            <Box container spacing={2}>
                <Card>
                    <HighChartStack 
                        title={`Dépenses Par Catégorie`}
                        titleY="Montant FCFA"
                        type="column"
                        categories={info_stack.categories}
                        series={info_stack.series}
                        colors={info_stack.bckg}
                        disableLegend={true}
                    />
                    
                </Card>
               
            </Box>
        );
    }
}

export default StackedGeneral;

